module.exports = "/img/logo.png?50d7ef9a42e9b1592ce3dee2b7b1f20d";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo.png
// module id = I2iN
// module chunks = 54